import { useEffect, useMemo, useState } from "react";
import Insufficiency from "./hr-pending-action/Insufficiency";
import Footer from "../../core/common/Footer";
import useApi from "../../core/customhook/useApi";
import webservice_url from "../../core/webservice/Webservice_url";
import { ExclamationCircleOutlined } from "@ant-design/icons";

interface CountData {
  key: string;
  status_id?: string;
  label: string;
  count: number;
}

export const statusColors: Record<string, string> = {
  Pending: "bg-warning",
  Completed: "bg-soft-success",
  "In Progress": "bg-soft-secondary",
};

const ACTIVE_TAB_KEY = "active-hr-action-tab";

const HrPendingAction = () => {
  const [data, setData] = useState<CountData[]>([]);

  const getTotalCounts = useApi<any>(webservice_url.HrPendingCounts, {
    method: "POST",
    autoCall: false,
    handleGlobalError: false,
  });

  const getCount = (key: string) =>
    data.find((item) => item.key === key)?.count ?? 0;

  const getStatusId = (key: string) =>
    data.find((item) => item.key === key)?.status_id ?? "";

  // const HrPendingStats = useMemo(
  //   () => [
  //     {
  //       id: "insufficiency",
  //       label: "Insufficiency Cases",
  //       count: getCount("CANDIDATE_INSUFF"),
  //       component: <Insufficiency statusId={getStatusId("CANDIDATE_INSUFF")} />,
  //     },
  //   ],
  //   [data],
  // );

  const HrPendingStats = useMemo(
    () => [
      {
        id: "insufficiency",
        label: "Insufficiency Cases",
        icon: <ExclamationCircleOutlined />,
        count: getCount("CANDIDATE_INSUFF"),
        component: <Insufficiency statusId={getStatusId("CANDIDATE_INSUFF")} />,
      },
    ],
    [data],
  );

  const [activeTab, setActiveTab] = useState<string>(() => {
    try {
      return localStorage.getItem(ACTIVE_TAB_KEY) || "insufficiency";
    } catch {
      return "insufficiency";
    }
  });

  useEffect(() => {
    const valid = HrPendingStats.some((tab) => tab.id === activeTab);

    if (!valid) {
      setActiveTab(HrPendingStats[0]?.id || "insufficiency");
    }
  }, [HrPendingStats, activeTab]);

  const fetchData = async () => {
    try {
      const res = await getTotalCounts.callApi({});
      setData(res?.data ?? []);
    } catch (err) {
      console.error(err);
      setData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleTabClick = (d: { id: string }) => {
    setActiveTab(d.id);

    try {
      localStorage.setItem(ACTIVE_TAB_KEY, d.id);
    } catch (err) {
      console.error("Failed to save active tab:", err);
    }
  };

  const activeItem = HrPendingStats.find((item) => item.id === activeTab);
  const CaseMark = () => (
    <svg
      className="tcp-case-mark"
      viewBox="0 0 40 32"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="0" y="14" width="4" height="18" rx="1.5" />
      <rect x="9" y="8" width="4" height="24" rx="1.5" />
      <rect x="18" y="0" width="4" height="32" rx="1.5" />
      <rect x="27" y="10" width="4" height="22" rx="1.5" />
      <rect x="36" y="18" width="4" height="14" rx="1.5" />
    </svg>
  );
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="tcp-header-title-row mb-3">
          <CaseMark />
          <div>
            <h4 className="tcp-title">HR Action Required</h4>
            <p className="tcp-subtitle">
              Review cases requiring HR attention, resolve documentation or
              information gaps, and take action on pending screening checks.
            </p>
          </div>
        </div>
        <ul className="invite-tabs">
          {HrPendingStats.map((tab) => (
            <li key={tab.id}>
              <button
                type="button"
                className={`invite-btn ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => handleTabClick(tab)}
              >
                <span className="d-flex align-items-center justify-content-center gap-2">
                  {tab.icon}
                  <span>{tab.label}</span>
                </span>

                {typeof tab.count === "number" && (
                  <span className="d-block fw-semibold">{tab.count}</span>
                )}
              </button>
            </li>
          ))}
        </ul>

        <div className="mt-3">{activeItem?.component}</div>
      </div>

      <Footer />
    </div>
  );
};

export default HrPendingAction;
